import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "kt_sidebar_content",
  class: "py-10 px-7 px-lg-12"
}
const _hoisted_2 = {
  class: "hover-scroll-y me-lg-n7 pe-lg-5",
  "data-kt-scroll": "true",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-offset": "10px",
  "data-kt-scroll-wrappers": "#kt_sidebar_content"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column text-center mb-10" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fs-2 fw-bolder mb-2" }, "Add New Product"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-6 fw-bolder" }, "Quick Create Form")
], -1)
const _hoisted_4 = { class: "d-flex mb-8 justify-content-between" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-70px me-4 bg-light" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "symbol-label",
    style: {"background-image":"url('media/products/11.png')"}
  })
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-70px me-4" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "symbol-label",
    style: {"background-image":"url('media/products/12.png')"}
  })
], -1)
const _hoisted_7 = { class: "symbol symbol-70px" }
const _hoisted_8 = {
  href: "#",
  class: "h-70px w-70px btn btn-light d-flex flex-column flex-center fw-bolder p-0"
}
const _hoisted_9 = { class: "svg-icon svg-icon-1 svg-icon-gray-600 m-0" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Upload ")
const _hoisted_11 = { class: "mt-5" }
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"mb-4 fw-bolder fs-6\">Product Info</div><div class=\"mb-8\"><label class=\"fw-bolder\">Name</label><input type=\"text\" class=\"form-control form-control-solid form-control-lg\" placeholder=\"\"></div><div class=\"mb-8\"><label class=\"fw-bolder\">Category</label><select class=\"form-select form-select-solid form-select-lg\" data-control=\"select2\" data-placeholder=\"Select Category...\" data-hide-search=\"true\"><option value=\"mens\">Mens</option><option value=\"womens\">Womens</option><option value=\"accessories\">Accessories</option><option value=\"technology\">Technology</option><option value=\"appliances\">Appliances</option></select></div><div class=\"mb-8\"><label class=\"fw-bolder\">Size</label><select class=\"form-select form-select-solid form-select-lg\" data-control=\"select2\" data-placeholder=\"Select Size...\" data-hide-search=\"true\"><option value=\"xs\">XS</option><option value=\"s\">S</option><option value=\"m\" selected>M</option><option value=\"l\">L</option><option value=\"xl\">XL</option></select></div><div class=\"mb-8\"><label class=\"fw-bolder\">Description</label><textarea class=\"form-control form-control-solid form-control-lg\" rows=\"3\"></textarea></div><div class=\"mb-8\"><label class=\"fw-bolder\">Price (Euro)</label><input type=\"text\" class=\"form-control form-control-solid form-control-lg\" placeholder=\"\"></div><button type=\"submit\" class=\"btn btn-primary fw-bolder me-2 px-8\"> Save </button>", 7)
const _hoisted_19 = { class: "d-flex flex-column text-center bg-light rounded py-8 px-5 mb-10" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h3", { class: "fs-2 fw-bolder mb-2" }, "Add New Product", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-6 fw-bolder" }, "Quick Create Form", -1)
const _hoisted_22 = { class: "form" }
const _hoisted_23 = /*#__PURE__*/_createStaticVNode("<div class=\"mb-11\"><label class=\"fs-2 fw-bolder text-dark mb-7\">Categories</label><div class=\"form-check form-check-custom form-check-solid mb-5\"><input class=\"form-check-input\" type=\"checkbox\" id=\"kt_checkbox_1\" value=\"1\"><label class=\"form-check-label fw-bold text-gray-600\" for=\"kt_checkbox_1\">Electronics</label></div><div class=\"form-check form-check-custom form-check-solid mb-5\"><input class=\"form-check-input\" type=\"checkbox\" id=\"kt_checkbox_2\" value=\"1\"><label class=\"form-check-label fw-bold text-gray-600\" for=\"kt_checkbox_2\">Sports Equipments</label></div><div class=\"form-check form-check-custom form-check-solid mb-5\"><input class=\"form-check-input\" type=\"checkbox\" id=\"kt_checkbox_3\" value=\"1\"><label class=\"form-check-label fw-bold text-gray-600\" for=\"kt_checkbox_3\">Appliances</label></div><div class=\"form-check form-check-custom form-check-solid mb-5\"><input class=\"form-check-input\" type=\"checkbox\" id=\"kt_checkbox_4\" value=\"1\"><label class=\"form-check-label fw-bold text-gray-600\" for=\"kt_checkbox_4\">Software Solutions</label></div><div class=\"form-check form-check-custom form-check-solid mb-5\"><input class=\"form-check-input\" type=\"checkbox\" id=\"kt_checkbox_5\" value=\"1\"><label class=\"form-check-label fw-bold text-gray-600\" for=\"kt_checkbox_4\">Food &amp; Groceries</label></div></div><div class=\"mb-7\"><label class=\"fs-2 fw-bolder text-dark mb-7\">Price</label><div class=\"form-check form-check-custom form-check-solid mb-5\"><input class=\"form-check-input\" type=\"radio\" id=\"kt_radio_1\" value=\"1\" name=\"prices\"><label class=\"form-check-label fw-bold text-gray-600\" for=\"kt_radio_1\">All</label></div><div class=\"form-check form-check-custom form-check-solid mb-5\"><input class=\"form-check-input\" type=\"radio\" id=\"kt_radio_2\" value=\"1\" name=\"prices\"><label class=\"form-check-label fw-bold text-gray-600\" for=\"kt_radio_2\">0$ - 99$</label></div><div class=\"form-check form-check-custom form-check-solid mb-5\"><input class=\"form-check-input\" type=\"radio\" id=\"kt_radio_3\" value=\"1\" name=\"prices\"><label class=\"form-check-label fw-bold text-gray-600\" for=\"kt_radio_3\">100$ - 999$</label></div><div class=\"form-check form-check-custom form-check-solid mb-5\"><input class=\"form-check-input\" type=\"radio\" id=\"kt_radio_4\" value=\"1\" name=\"prices\"><label class=\"form-check-label fw-bold text-gray-600\" for=\"kt_radio_4\">1000$ &amp; Above</label></div></div>", 2)
const _hoisted_25 = { class: "mb-13" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "text-dark fw-bolder fs-6 mb-5" }, "Pricing Range", -1)
const _hoisted_27 = {
  id: "kt_price_slider",
  ref: "sliderRef",
  class: "nouislider nouislider-light nouislider-handle-primary nouislider-bg-dark-15 nouislider-shadowless nouislider-borderless"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "mb-11" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "fs-2 fw-bolder text-dark mb-7" }, "Sizes"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "d-flex",
    role: "group"
  }, [
    /*#__PURE__*/_createElementVNode("input", {
      type: "radio",
      class: "btn-check",
      name: "sizes",
      id: "kt_size_1"
    }),
    /*#__PURE__*/_createElementVNode("label", {
      class: "btn btn-active-primary btn-lg btn-icon btn-light btn-active-primary fw-bold h-35px w-35px mx-1",
      for: "kt_size_1"
    }, "XS"),
    /*#__PURE__*/_createElementVNode("input", {
      type: "radio",
      class: "btn-check",
      name: "sizes",
      id: "kt_size_2"
    }),
    /*#__PURE__*/_createElementVNode("label", {
      class: "btn btn-active-primary btn-lg btn-icon btn-light btn-active-primary fw-bold h-35px w-35px mx-1",
      for: "kt_size_2"
    }, "S"),
    /*#__PURE__*/_createElementVNode("input", {
      type: "radio",
      class: "btn-check",
      checked: "",
      name: "sizes",
      id: "kt_size_3"
    }),
    /*#__PURE__*/_createElementVNode("label", {
      class: "btn btn-active-primary btn-lg btn-icon btn-light btn-active-primary fw-bold h-35px w-35px mx-1",
      for: "kt_size_3"
    }, "M"),
    /*#__PURE__*/_createElementVNode("input", {
      type: "radio",
      class: "btn-check",
      name: "sizes",
      id: "kt_size_4"
    }),
    /*#__PURE__*/_createElementVNode("label", {
      class: "btn btn-active-primary btn-lg btn-icon btn-light btn-active-primary fw-bold h-35px w-35px mx-1",
      for: "kt_size_4"
    }, "L"),
    /*#__PURE__*/_createElementVNode("input", {
      type: "radio",
      class: "btn-check",
      name: "sizes",
      id: "kt_size_5"
    }),
    /*#__PURE__*/_createElementVNode("label", {
      class: "btn btn-active-primary btn-lg btn-icon btn-light btn-active-primary fw-bold h-35px w-35px mx-1",
      for: "kt_size_5"
    }, "XL")
  ])
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("button", {
  type: "reset",
  class: "btn btn-primary fw-bolder me-2 px-8"
}, " Reset ", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-color-gray-600 btn-active-light-primary fw-bolder px-8" }, " Setup ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass({ 'd-none': _ctx.displayFilterForm }),
        id: "kt_sidebar_shop_new_form"
      }, [
        _hoisted_3,
        _createElementVNode("form", {
          class: "form",
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.newProductFormSubmit && _ctx.newProductFormSubmit(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("a", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotone/Design/Image.svg" })
                ]),
                _hoisted_10
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("button", {
              type: "reset",
              id: "kt_sidebar_shop_filter_form_btn",
              class: "btn btn-color-gray-600 btn-active-light-primary fw-bolder px-8",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showProductFilterForm && _ctx.showProductFilterForm(...args)))
            }, " Discard ")
          ])
        ], 32)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass({ 'd-none': !_ctx.displayFilterForm }),
        id: "kt_sidebar_shop_filter_form"
      }, [
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _hoisted_21,
          _createElementVNode("button", {
            id: "kt_sidebar_shop_new_form_btn",
            class: "btn btn-primary fw-bolder mx-auto px-5 mt-6",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showProductAddForm && _ctx.showProductAddForm(...args)))
          }, " Create New ")
        ]),
        _createElementVNode("form", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createElementVNode("div", _hoisted_27, null, 512)
          ]),
          _hoisted_28,
          _hoisted_29,
          _hoisted_30
        ])
      ], 2)
    ])
  ]))
}